import { render, staticRenderFns } from "./QuestionAnswerEdit.vue?vue&type=template&id=acc7cd62&scoped=true"
import script from "./QuestionAnswerEdit.vue?vue&type=script&lang=js"
export * from "./QuestionAnswerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc7cd62",
  null
  
)

export default component.exports